export const sendYandexEvent = (eventName: string, value: any) => {
  if (window.ym && import.meta.env.VITE_YANDEX_METRIK_KEY) {
    window.ym(import.meta.env.VITE_YANDEX_METRIK_KEY, eventName, value);
  }
};
